<template>
  <div class="AddTrainee">
    <el-dialog
        :title="isAdd?isAddContent:isEditContent"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        @open=""
    >
      <div>
        <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
          <el-form-item label="姓名" prop="nickname">
            <el-input style="width: 30%" v-model="formData.nickname"></el-input>
          </el-form-item>

          <el-form-item label="手机号码" prop="phone">
            <el-input style="width: 30%" v-model="formData.phone"></el-input>
          </el-form-item>
          <el-form-item label="工作单位" prop="unitName">
            <el-input style="width: 30%" v-model="formData.unitName"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="roleIds">
            <el-select
                style="width: 30%"
                v-model="formData.sex"
                placeholder="请选择"
            >
              <el-option
                  v-for="item in sexOption"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出生日期" prop="birthday">
            <el-date-picker
                style="width: 30%"
                v-model="formData.birthday"
                type="date"
                value-format="timestamp"
                placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer">
        <el-button style="width: 30%;" type="primary" @click="handleConfirm">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AppBox from "@/components/ui/AppBox/index.vue";
import {mapActions} from "vuex";
import {SEX} from "@/utils/constants";

export default {
  name: "AddTrainee",
  components: {AppBox},
  mixins: [],
  data() {
    const sexOption = Object.keys(SEX).map((key) => {
      return {
        id: Number(key),
        name: SEX[key],
      };
    });
    return {
      sexOption: sexOption,
      formData: {sex: 0},
      rules: {
        nickname: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur"],
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur"],
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: ["blur", "change"],
          },
        ],
      },
      visible: false,
      isAdd: true,
      isAddContent: "新增学员",
      isEditContent: "更新学员",
    };
  },
  computed: {},
  async mounted() {
  },
  methods: {
    ...mapActions("administrativeCenter", ["saveTenantTrainee", "getTenantTraineeList"]),
    initData(data) {
      if (data) {
        this.formData = {...data};
      } else {
        this.formData = {sex: 0};
      }
      this.visible = true;
    },
    async handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        await this.saveTenantTrainee(this.formData);
        await this.getTenantTraineeList({});
        this.visible = false;
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.AddTrainee {
  .footer {
    text-align: center;
    bottom: 200px;
    right: 50px;
    left: 50px;
  }
}
</style>
